import { createSlice } from "@reduxjs/toolkit";
import initialState from "./state";
import { fetchLanguages } from "./actionCreator";
import { getErrorMessage } from "../../../utils/common";

export const headerSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    setLanguages(state, { payload }) {
			state.languagesData = { ...state.languagesData, ...payload };
		},
    setCurrentLanguage(state, { payload }) {
			state.currentLanguage = { ...state.currentLanguage, ...payload };
		},
  },
  extraReducers: (builder) => {
    /*-------------------------------- GET LANGUAGES ---------------------------------*/
    builder.addCase(fetchLanguages.pending, (state) => {
      state.languagesData = {
        isLoading: true,
        isError: false,
        error: '',
        data: [],
      }
    }).addCase(fetchLanguages.fulfilled, (state, { payload }) => {
        state.languagesData = {
          isLoading: false,
          isError: false,
          error: '',
          data: payload.languages || [],
        }
      },
    ).addCase(fetchLanguages.rejected, (state, { error }) => {
        const m = getErrorMessage(error.message);
        state.languagesData = {
          isLoading: false,
          isError: true,
          error: m,
          data: [],
        }
      },
    );
  },
});

export const { setLanguages, setCurrentLanguage } = headerSlice.actions;

export default headerSlice.reducer;
